import { useEffect, useState } from 'react';

const addPhoneNumberMask = (number) => {
  if (number && typeof number === 'string') {
    if (number.startsWith('(')) {
      return number;
    }
    let splittedNumber = number.split(' ');
    if (splittedNumber.length === 2) {
      if (splittedNumber[0].includes('-')) {
        const numb = splittedNumber[0].split('-');
        const adds = splittedNumber[1];
        return `(${numb[0]}) ${numb[1]}-${numb[2]} ${adds}`;
      }
      return `(${splittedNumber[0]}) ${splittedNumber[1].slice(0, 3)}-${splittedNumber[1].slice(
        3,
        splittedNumber[1].length,
      )}`;
    }
    if (splittedNumber.length === 3) {
      return `(${splittedNumber[0]}) ${splittedNumber[1]}-${splittedNumber[2]}`;
    }
    splittedNumber = number.split('-');
    if (splittedNumber.length === 3) {
      return `(${splittedNumber[0]}) ${splittedNumber[1]}-${splittedNumber[2]}`;
    }
    if (splittedNumber.length === 1) {
      return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(
        6,
        10,
      )}`;
    }
    return number;
  }
  return '';
};

const ContactDetailTab = ({
  unit,
  showBudgetInformation,
  openWorksheetPDF,
  fetchTaxingUnit,
  isPID,
}) => {
  const [contactData, setContactData] = useState({});

  useEffect(() => {
    const getData = async () => {
      const res = await fetchTaxingUnit({
        id: unit.taxingUnitID,
      });
      if (res?.results) {
        setContactData(res.results[0] || {});
      }
    };
    getData();
  }, [fetchTaxingUnit, unit.taxingUnitID]);

  return (
    <div>
      <div className='unit-info-container'>
        <div>
          <span className='title'>
            {isPID ? 'PID Assessment Contact Info' : 'Taxing Unit Contact Info'}
          </span>
          <div>
            <span className='sub-title'>
              {isPID ? 'PID Assessment Name:' : 'Taxing Unit Name:'}{' '}
            </span>
            <span>{contactData.taxingUnitName}</span>
          </div>
          <div>
            <span className='sub-title'>Website:&nbsp;</span>
            {contactData.url && (
              <a
                href={
                  contactData.url.toLowerCase().includes('http')
                    ? contactData.url
                    : `https://${contactData.url}`
                }
                rel='noopener noreferrer'
                target='_blank'
              >
                <span style={{ whiteSpace: 'nowrap' }}>{contactData.url}</span>
              </a>
            )}
          </div>
          {contactData.urlSecondary && (
            <div>
              <span className='sub-title' />
              <a
                href={
                  contactData.urlSecondary.toLowerCase().includes('http')
                    ? contactData.urlSecondary
                    : `https://${contactData.urlSecondary}`
                }
                rel='noopener noreferrer'
                target='_blank'
              >
                <span style={{ whiteSpace: 'nowrap' }}>
                  {contactData.urlSecondary}
                </span>
              </a>
            </div>
          )}
          <div>
            <span className='sub-title'>Phone Number: </span>
            <span>{addPhoneNumberMask(contactData.phone)}</span>
          </div>
          <div>
            <span className='sub-title'>Email: </span>
            <span>{contactData.email}</span>
          </div>
        </div>
        <div>
          <span className='title'>Tax Assessor Collector</span>
          <div>
            <span className='sub-title'>Assessor Collector: </span>
            <span>{contactData.taxingUnitCollector}</span>
          </div>
          <div>
            <span className='sub-title'>Website:&nbsp;</span>
            {contactData.taxingUnitCollectorUrl && (
              <a
                href={
                  contactData.taxingUnitCollectorUrl
                    .toLowerCase()
                    .includes('http')
                    ? contactData.taxingUnitCollectorUrl
                    : `https://${contactData.taxingUnitCollectorUrl}`
                }
                rel='noopener noreferrer'
                target='_blank'
              >
                <span style={{ whiteSpace: 'nowrap' }}>
                  {contactData.taxingUnitCollectorUrl}
                </span>
              </a>
            )}
          </div>
          <div>
            <span className='sub-title'>Phone Number: </span>
            <span>
              {addPhoneNumberMask(contactData.taxingUnitCollectorPhone)}
            </span>
          </div>
          <div>
            <span className='sub-title'>Email: </span>
            <span>{contactData.taxingUnitCollectorEmail}</span>
          </div>
        </div>
        <div>
          {showBudgetInformation && (
            <>
              <span className='title'>Budget & Tax Rates</span>
              <div>
                <span className='sub-title'>Budget & Rate Information: </span>
                {contactData.budgetRateInformationS3ID ? (
                  <button
                    className='link-button'
                    onClick={() =>
                      openWorksheetPDF('budget', unit.taxingUnitID)
                    }
                    type='button'
                  >
                    <span>Worksheet PDF</span>
                  </button>
                ) : (
                  <span>No Document</span>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactDetailTab;
